import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7a0f743a&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a0f743a')) {
      api.createRecord('7a0f743a', component.options)
    } else {
      api.reload('7a0f743a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7a0f743a&", function () {
      api.rerender('7a0f743a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/memorial/index.vue"
export default component.exports